import React from 'react'
import { Link } from '@material-ui/core'
import { Link as ReachLink } from '@reach/router'

export default function CustomLink(props) {
  /**
    |--------------------------------------------------
    | Props
    |--------------------------------------------------
    */
  const { to, children } = props

  /**
    |--------------------------------------------------
    | Render
    |--------------------------------------------------
    */
  return (
    <ReachLink to={to} style={styles}>
      <Link component="p" color="textSecondary">
        {children}
      </Link>
    </ReachLink>
  )
}

const styles = {
  textDecoration: 'none'
}
